import { If } from "components";
import isEmpty from "lodash/isEmpty";
import { useTranslation } from "react-i18next";
import { ClipLoader } from "react-spinners";
import { Modal } from "ui";

import {
  useCreateSubCategory,
  useGetCategoryById,
  useUpdateSubCategory
} from "../../../apis";
import { useCategoriesNavigation } from "../../../hooks";
import { CategoryModalProps } from "../../components.types";
import { CategoryForm, CategoryFormData } from "../../forms";
import { ModalFooter } from "../atoms";

import styles from "./SubCategoryModal.module.scss";

const SUB_CATEGORY_FORM_ID = "sub-category-form-id";

const SubCategoryModal = ({
  isOpen,
  category,
  renderDeleteCategory,
  refetchCategories,
  onClose
}: CategoryModalProps) => {
  const { t } = useTranslation();
  const isUpdateCategory = !isEmpty(category);

  const { mainCategoryId } = useCategoriesNavigation();

  const { category: editableCategory, isFetching: isEditableCategoryFetching } =
    useGetCategoryById(category?.id);

  const onSuccessActionCategory = () => {
    refetchCategories();
    onClose();
  };

  const {
    isLoading: isLoadingCreateSubCategory,
    mutate: mutateCreateSubCategory
  } = useCreateSubCategory({
    onSuccess: onSuccessActionCategory
  });

  const {
    isLoading: isLoadingUpdateSubCategory,
    mutate: mutateUpdateSubCategory
  } = useUpdateSubCategory({
    onSuccess: onSuccessActionCategory
  });

  const onSubmit = (formData: CategoryFormData) => {
    const { name } = formData;

    return isUpdateCategory
      ? mutateUpdateSubCategory({
          id: category.id,
          name
        })
      : mutateCreateSubCategory({
          parentCategoryId: mainCategoryId,
          name
        });
  };

  return (
    <Modal
      formId={SUB_CATEGORY_FORM_ID}
      className={styles["sub-category-modal"]}
      isOpen={isOpen}
      title={t(`${isUpdateCategory ? "Edit" : "New"} Sub-category`)}
      isLoading={isLoadingCreateSubCategory || isLoadingUpdateSubCategory}
      okText={isUpdateCategory ? t("Save") : t("Create")}
      extraFooter={ModalFooter({
        renderDeleteCategory,
        isEditableCategoryFetching,
        editableCategory
      })}
      onClose={onClose}
    >
      <If condition={isUpdateCategory && !editableCategory}>
        <div className={styles["sub-category-modal_loader"]}>
          <ClipLoader size={30} color="#fb3973" />
        </div>
      </If>

      <If condition={!isUpdateCategory || editableCategory}>
        <CategoryForm
          formId={SUB_CATEGORY_FORM_ID}
          category={editableCategory ?? null}
          onSubmit={onSubmit}
        />
      </If>
    </Modal>
  );
};

export default SubCategoryModal;
